import { IsString } from 'class-validator';

export class GiftCardRedemptionRequest {
  @IsString()
  cardNumber: string;

  amount: number | string;

  posDeviceId?: number;

  employeeId?: number;
}
